export default __webpack_public_path__ + "static/media/H'Wear Front Centre.215e668b.jpg";